import { textWithFirstCharUpper } from "../helpers/string";
import { Constants } from "../utils/constants";
import { api } from "./api";

export const getAllBrandList = async (pageSize, pageNo, searchText) => {
  let filter = ``;
  if (searchText != "" && searchText != undefined) {
    filter = `&search=${searchText}`;
  }
  const query = encodeURI(
    `?pageSize=${pageSize}${filter}&page=${pageNo}&restrictFields=actions&sort=dateCreated:desc`
  );
  // const query = encodeURI(`?filter=applicationStatus eq 'SUBMITTED' or applicationStatus eq 'IN_REVIEW' &pageSize=${pageSize}&page=${pageNo}&fields=id,nameOfApplicantFirm,primaryContactName,primaryContactEmail,dateCreated,applicationStatus,isOpened&restrictFields=actions&sort=dateCreated:desc`)
  // const filter = encodeURI(`?pageSize=${pageSize}&page=${pageNo}&fields=id,nameOfApplicantFirm,primaryContactName,primaryContactEmail,dateCreated`)
  return api
    .get(Constants.URL.brandsUrl)
    .then((res) => res)
    .catch((error) => console.error(error));
};

export const checkUserMigrated = async (emailAddress) => {
  console.log("final formdata", emailAddress);
  const query = encodeURI(`?emailAddress=${emailAddress}`);
  const payload = {
    emailAddress: emailAddress
  }

  return api
    .post(Constants.URL.verifyUserEmail, JSON.stringify(payload), {
      headers: {
        "content-type": "application/json",
      }})
    .then((res) => res)
    .catch((error) => console.error(error));
};

export const getMigDetailsById = async (emiratesId) => {
  return api
    .get(Constants.URL.checkemiratesID + `?emiratesId=${emiratesId}`)
    .then((res) => res)
    .catch((error) => console.error(error));
};

export const submitUserform = async (userstate) => {
  const updatedUserState = {
    ...userstate,
    emailAddress: "",
  };
  console.log("final formdata", updatedUserState);

  return api
    .post(Constants.URL.createMigreatedUser, JSON.stringify(updatedUserState), {
      headers: {
        "content-type": "application/json",
      },
    })
    .catch((e) => console.log(e));
};

export const updateBrandForm = async (formData, brandId) => {
  return api
    .put(Constants.URL.brandsUrl + "/" + brandId, JSON.stringify(formData), {
      headers: {
        "content-type": "application/json",
      },
    })
    .catch((e) => console.log(e));
};

export const getBrandByID = async (brandId) => {
  const query = encodeURI("?brandId=" + brandId);
  return api
    .get(Constants.URL.brandDetail + query)
    .catch((e) => console.log(e));
};

export const getBrandAttachmentsByID = async (brandId) => {
  const query = encodeURI(`?filter=accountId eq ${brandId}&fields=attachments`);
  return api
    .get(Constants.URL.brandsAttachmentUrl + query)
    .catch((e) => console.log(e));
};
